import $ from 'jquery';
import { call, put } from 'redux-saga/effects';

import {
    showCannotAddToListError,
    hideCannotAddToListError
} from '../actions/productActions';
import {
    checkProductRegistries,
    setRegistryItemRemainingQuantity,
    setPurchasedQuantity,
} from '../../../registry/js/actions/registryActions';

import { generate } from '../../../core/js/utils/componentUtils';
import { mDom } from '../../../core/js/utils/renderUtils';

import template from 'product-registry-add.j2';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-add-to-registry',
        onStateChange: onStateChange,
        attachEvents: attachEvents,
        watch: ['registry', 'product.productRegistry'],
        template: template,
        name: 'productRegistryComponent',
        forFamilyProduct: false,
        listName: 'REGISTRY',
        renderType: mDom
    };

    return generate(config, store, overrides);
}

/**
 * Attach watcher to the store to trigger a render
 * @param {object} store The store
 */
export function onStateChange(store) {
    const product = this.getTargetedProduct(store.getState());
    this.render(store, this, {
        product: product,
        forFamilyProduct: this.forFamilyProduct,
    });
}

function* formValidation(e, action, component) {
    const formEl = $(component.templateLocation).parents('.js-product-add-form');
    const formParsley = formEl.parsley();
    if (formEl.length > 0) {
        yield put([formParsley, formParsley.whenValidate]);
        const valid = yield call([formParsley, formParsley.isValid]);
        if (valid) {
            yield put(hideCannotAddToListError(component));
            yield put(action);
        } else {
            yield put(showCannotAddToListError(component));
        }
    } else {
        yield put(action);
    }
}

function attachEvents(store) {
    $(document).on(
        this.scopedEvent('click'),
        this.scopedSelector('.js-create-registry-ui'),
        (e) => {
            e.preventDefault();

            // Toggle wishlist states to closed
            $(this.scopedSelector()).siblings('.dom-wishlist-add')
                .find('.js-create-wishlist-ui')
                .removeClass('is-open');
            $(this.scopedSelector()).siblings('.dom-wishlist-list')
                .find('.js-product-add-links__ul')
                .hide();

            const meta = {
                component: this,
                event: e
            };
            const onValidFormAction = checkProductRegistries({}, meta);
            store.runSaga(formValidation, e, onValidFormAction, this);
        }
    );

    $(document).on(
        this.scopedEvent('change'),
        '.js-quickshop-registry__requested-quantity',
        (e) => {
            const remainingQuantityElem = document.querySelector('.js-quickshop-registry__remaining-quantity');
            const remainingQuantity = parseInt(remainingQuantityElem.value, 10);
            const oldRequestedValue = parseInt(
                document.querySelector('.js-quickshop-registry__requested-quantity [selected]').value,
                10,
            );

            const requestedQuantity = parseInt(e.target.value, 10);
            const purchased = oldRequestedValue - remainingQuantity;

            store.dispatch(setRegistryItemRemainingQuantity({ requestedQuantity }));
            remainingQuantityElem.querySelector(`[data-qa-qty="${requestedQuantity - purchased}"]`)
                .setAttribute('selected', true);
        }
    );

    $(document).on(
        this.scopedEvent('change'),
        '.js-quickshop-registry__remaining-quantity',
        (e) => {
            const registry = _.get(store.getState(), 'registry');
            const requestedQuantityElem = document.querySelector('.js-quickshop-registry__requested-quantity');
            const requestedValue = parseInt(
                _.get(registry, 'requestedQuantity') || requestedQuantityElem.value,
                10,
            );
            const remainingQuantity = parseInt(e.target.value, 10);
            const purchasedQuantity = Math.max(0, requestedValue - remainingQuantity);
            store.dispatch(setPurchasedQuantity({ purchasedQuantity }));
            requestedQuantityElem.querySelector(`[data-qa-qty="${requestedValue}"]`)
                .setAttribute('selected', true);
        }
    );

    $(document).on('a15-quickshop-close', (e) => {
        const registry = _.get(store.getState(), 'registry');

        if (!_.isEmpty(registry)) {
            if (_.get(registry, 'requestedQuantity') !== null) {
                store.dispatch(setRegistryItemRemainingQuantity({ requestedQuantity: null }));
            }
            if (_.get(registry, 'purchasedQuantity') !== null) {
                store.dispatch(setPurchasedQuantity({ purchasedQuantity: null }));
            }
        }
    });
}
